<script setup lang="ts">
import type { BlokFaq } from "@/.storyblok/types/120421/storyblok-components";
import { convert as convertRichtextToPlainText } from "html-to-text";

const props = defineProps<{ blok: BlokFaq }>();

const siteConfig = useSiteConfig();

useSchemaOrg([
  defineQuestion({
    name: props.blok.question,
    answer: convertRichtextToPlainText(renderRichText(props.blok.answer), {
      selectors: [{ selector: "a", options: { baseUrl: siteConfig.url } }],
    }),
  }),
]);
</script>

<template>
  <BaseHeadline
  v-editable="blok"
    tag="h3"
    :text="blok.question"
    :responsive="false"
    class="mb-4"
  />
  <BaseRichtext :content="blok.answer" />
</template>
